import * as React from "react";
import { LocalizeContextProps, withLocalize } from "react-localize-redux";
import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    makeStyles,
    tokens,
} from "@fluentui/react-components";
import { NewformaButton } from "../../_base/Button";
import { Dismiss24Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
    surface: {
        maxWidth: "479px",
        minWidth: "unset",
        width: "calc(100% - 20px)",
        padding: "24px",
        margin: "auto",
    },
    title: {
        fontSize: tokens.fontSizeBase500,
        fontWeight: tokens.fontWeightSemibold,
        lineHeight: tokens.lineHeightBase500,
    },
    actions: {
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        gap: tokens.spacingHorizontalS,
    },
});

interface CancelFileTransferDialogProps extends LocalizeContextProps {
    isOpen: boolean;
    isCancelInProgress: boolean;
    onDismiss: () => void;
    onConfirm: () => void;
}

const CancelFileTransferDialogComponent: React.FC<CancelFileTransferDialogProps> = ({
    isOpen,
    isCancelInProgress,
    onDismiss,
    onConfirm,
    translate,
}) => {
    const styles = useStyles();

    return (
        <Dialog
            open={isOpen}
            onOpenChange={(_event, data) => {
                if (!data.open) {
                    onDismiss();
                }
            }}
            modalType="modal"
        >
            <DialogSurface className={styles.surface} data-testid="file-transfer-cancel-dialog">
                <DialogBody>
                    <DialogTitle
                        className={styles.title}
                        action={
                            <Button
                                data-testid="file-transfer-cancel-dialog-close-button"
                                appearance="subtle"
                                aria-label={translate("FLUENT9.CLOSE") as string}
                                icon={<Dismiss24Regular />}
                                onClick={onDismiss}
                            />
                        }
                    >
                        {translate("FLUENT9.CANCEL_FILE_TRANSFER") as string}
                    </DialogTitle>
                    <DialogContent>{translate("APP.FILE_TRANSFER.CANCEL_TEXT") as string}</DialogContent>
                    <DialogActions>
                        <div className={styles.actions}>
                            <NewformaButton
                                testid="file-transfer-cancel-dialog-no"
                                appearance="outline"
                                onClick={onDismiss}
                                disabled={isCancelInProgress}
                            >
                                {translate("FLUENT9.NO_CONTINUE") as string}
                            </NewformaButton>
                            <NewformaButton
                                testid="file-transfer-cancel-dialog-yes"
                                appearance="primary"
                                onClick={onConfirm}
                                disabled={isCancelInProgress}
                            >
                                {translate("FLUENT9.YES_CANCEL") as string}
                            </NewformaButton>
                        </div>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};

export default withLocalize(CancelFileTransferDialogComponent);
